module.exports = __webpack_public_path__ + "img/BVLGARI.c6fac24c.jpg";